import { useTranslation } from 'react-i18next';

import { AddIcon } from '@treams/treams-icons';
import { IdentityProvider, useIdentityProvidersSettingsQuery } from '@treams/treams-network';
import { Button, Container, Jumbo, Table, tokens } from '@treams/treams-ui';

import { IntegrationsTabs } from '../Connectors';

export default function SSOList() {
	const { t } = useTranslation();
	const { data, error, loading } = useIdentityProvidersSettingsQuery();

	return (
		<>
			<Jumbo
				title={t('settings.integrations.sso.list.title')}
				button={
					<Button
						link="/settings/integrations/sso/create"
						title={t('settings.integrations.sso.list.create')}
						icon={<AddIcon />}
					/>
				}
				footer={<IntegrationsTabs />}
			/>
			<Container pt={`${tokens.gap.page}px`} pb={4}>
				<Table.List
					headers={[t('settings.integrations.sso.list.header.title')]}
					transformItem={(item: IdentityProvider) => ({
						link: `/settings/integrations/sso/${item.id}`,
						cells: [item.configuration?.name || t('settings.integrations.sso.id', { id: item.id })],
					})}
					data={data?.identityProviders}
					error={error}
					loading={loading}
					noDataText={t('settings.integrations.sso.list.empty')}
				/>
			</Container>
		</>
	);
}
